import { ArrowBack } from "@mui/icons-material";
import { use, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import { T } from "../i18n";

export const Chip = styled.div`
  position: absolute;
  left: 15px;
  top: 15px;
  padding: 9px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  z-index: 10;
  color: white;
  max-width: 78%;
  background: #000000cc;
`;

export const FlexDivider = styled.div`
    flex: 1
`;

export const VerticalDiv = styled.div`
  border-right: 1px solid gray;
  padding 10px 20px;
`;


export const TextSlice = ({text, lines, markdown, showMore}:any) => {
  
  const [show, setShow] = useState(0)
  const textRef = useRef<any>(null)
  const [showShowMore, setShowShowMore] = useState(false)


  useEffect(() => {
    if(textRef.current) {
      setShowShowMore(textRef.current.scrollHeight > textRef.current.clientHeight)
    }
  }, [text])

  useEffect(() => {
    if(textRef.current) {
      setShowShowMore(textRef.current.scrollHeight > textRef.current.clientHeight)
    }
  },[textRef.current])


  let sliced = text;
  if(markdown) {
    sliced = sliced.replace(/\n/g, "<br />")
  }

  let style = {}
  
  if(!show) {
      style = {
      "display": "-webkit-box",
      "-webkit-line-clamp": `${lines}`,
      "-webkit-box-orient": "vertical",
      "overflow": "hidden"
    }
  }

  const toggle = () => {
    setShow(show !== 0 ? 0 : 1);
  }

  return (
    <>
      {markdown ? (
        <span ref={textRef} style={style} dangerouslySetInnerHTML={{__html: sliced}}/>
      ): (
        <span ref={textRef} style={style}>
          {sliced}
        </span>
      )}
      {showMore && showShowMore && 
        <div className="showMore" onClick={() => toggle()}>
          {!show ? T('show_more'): T('show_less')}
        </div>
      }
    </>
  )
}

export const BackWidget = () => {
  const navigate = useNavigate();

  return (
    <div className="back-widget" onClick={() => navigate(-1)}><ArrowBack style={{width: 50, height: 50}} /> {T('back')}</div>
  )
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scrolls the window to the top (0,0) with no animation.
    window.scrollTo({ top: 0, left: 0 }); 
    const cont: any = document.querySelector('.header .searchbar-container')
    if(cont) {
      cont.style.display = "block"
    }
  }, [pathname]); // Re-run effect whenever the pathname changes

  return null; // This component doesn't render anything visually
}